import { PeriodContext } from '../../context/PeriodProvider';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { List } from '../ui/List';
import { Message } from '../ui/Message';
import { Skeleton } from '../ui/Skeleton';
import { UserContext } from '../../context/UserProvider';
import { useParams } from 'react-router-dom';
import { CarClient } from '../../services/CarClient';

const CarQueryKey = 'car';

export const Car = () => {
    const { period } = useContext(PeriodContext);
    const user = useContext(UserContext);
    const { id } = useParams();
    const { data, isPending, isError } = useQuery({
        queryKey: [CarQueryKey, period],
        queryFn: () => CarClient({ ...user, param: id }).getCar(period),
    });

    if (isError)
        return (
            <Message className="text-inherit" type="error">
                Er is iets misgegaan bij het ophalen van uw autogegevens. Probeer het later nog een keer.
            </Message>
        );

    if (isPending) {
        return (
            <div className="flex flex-col gap-2">
                {[...Array(3)].map((_, index) => (
                    <Skeleton className="w-full h-[30px] rounded-sm" key={index} />
                ))}
            </div>
        );
    }

    if (!data || data.length === 0) return <Message type="info">Geen data gevonden</Message>;

    return (
        <List>
            {data.map((item) => {
                return item.url ? (
                    <List.LinkItem key={item.key + item.value} title={item.key} label={item.value} href={item.url} />
                ) : (
                    <List.Item
                        key={item.key + item.value}
                        label={item.key}
                        value={item.value}
                        labelClassName="break-words"
                        valueClassName="whitespace-nowrap"
                    />
                );
            })}
        </List>
    );
};
